import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

const useNotifications = () => {
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      text: 'New opportunity created',
    },
  ])

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const getNotifcations = () => {
    return authedAxios
      .get('/api/notifications')
      .then((res) => {
        setNotifications(res.data.notifications)
      })
      .catch(() => {
        setHasLoadError(true)
      })
      .finally(() => setIsLoading(false))
  }

  const markNotificationComplete = (notification) => {
    return authedAxios
      .put(`/api/notifications/${notification.id}/mark-complete`)
      .then(getNotifcations)
  }

  useEffect(() => {
    getNotifcations()
  }, [])

  return {
    notifications,
    setNotifications,
    isLoading,
    hasLoadError,
    markNotificationComplete,
  }
}

export default useNotifications
